import * as React from 'react';
import {DataMultiBtnSelect, IMultiNode} from '../../../DataMultiBtnSelect';
import { PeriodsDataSource } from '../../DataSources';
interface IPeriodsFilterProps {
  values: string[]
  useMobileMode?: boolean
  onChange?: (values: string[], source: IMultiNode[]) => void
  onClosed?: () => void
  defaultValue?: string
  useLinkView?: boolean
  rightAlign?: boolean
  persistLabel?: boolean
  placeholder?: string
}

export class PeriodsFilter extends React.Component<IPeriodsFilterProps, {}> {

  render() {
    const { persistLabel = true, placeholder = 'Period' } = this.props

    return (
      <DataMultiBtnSelect
        placeholder={placeholder}
        source={PeriodsDataSource}
        useMobileMode={this.props.useMobileMode}
        rightAlign={this.props.rightAlign}
        useLinkView={this.props.useLinkView}
        values={this.props.values}
        defaultValue={this.props.defaultValue}
        onChange={this.props.onChange}
        onClosed={this.props.onClosed}
        persistLabel={persistLabel}
        hidePopoverOnLeadNodeSelect
        disableClearOnFirstSelect
        hidePopoverOnClear
      />
    )
  }
}
